export const QuickSearchHowToHint = $localize`:@@app.quick-search.how-to-hint:
Start typing to search for products.

You can search for:
  - Product Numbers
  - Cross reference numbers
  - Keywords
  - Product Descriptions
`;
